<template>
  <div>
    <v-hover v-slot:default="{ hover }" :disabled="!isAllResources()">
      <v-card
        @click:elevation="hover ? 12 : 2"
        style="z-index:0;cursor: pointer;"
      >
        <v-img
          height="156"
          :src="
            resource.thumbnails[0]
              ? resource.thumbnails[0].file_path
              : '/image-placeholder.png'
          "
          lazy-src="/image-placeholder.png"
          style="z-index:0"
          @click="gotoDetails()"
        ></v-img>

        <div
          v-if="!authToken.is_eblity_admin()"
          v-show="$store.state.isMobile || hover || resource.is_bookmarked"
          class="pa-2"
          style="position: absolute; top: 0; right: 0; background:#FFFFFF; border-radius: 0px 8px; z-index:1000"
          align="center"
          @click="addRemoveBookmark()"
        >
          <v-icon color="#5C658B" size="32">
            {{
              resource.is_bookmarked ? "mdi-bookmark" : "mdi-bookmark-outline"
            }}
          </v-icon>
        </div>

        <div
          v-if="isMyResource()"
          class="pa-2"
          style="position: absolute; top: 0; left: 0; background:#FFFFFF; border-radius: 8px 0px; z-index:1000; cursor: pointer;"
          align="center"
          @click="confirmDeleteAction = true"
        >
          <v-icon color="#ff4f5a" size="32">mdi-delete</v-icon>
        </div>

        <!-- <div
          class="resource-card-title px-4 mt-2"
          style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap; -webkit-line-clamp:2 height: 50px"
          @click="gotoDetails()"
        >{{resource.title}} KHJEHKWHR JKDHFJWHFKJ JKHREJKRHEWKJV JKHFEJFHWJKF HEJKHEJKRWHEVHJKHEWJFREH</div>-->
        <div class="resource-card-title px-4 mt-2" @click="gotoDetails()">
          {{ resource.title }}
          {{ resource.average_rating > 0 ? "(" : "" }}
          {{ resource.average_rating > 0 ? resource.average_rating : "" }}
          <v-icon
            v-if="resource.average_rating > 0"
            class="mb-"
            size="18"
            color="#ffac4a"
            >mdi-star</v-icon
          >
          {{ resource.average_rating > 0 ? ")" : "" }}
        </div>

        <v-card-text class="py-0" @click="gotoDetails()">
          <!-- <v-row align="center" class="mx-0">
            <v-rating
              :value="resource.average_rating"
              color="amber"
              dense
              half-increments
              readonly
              size="18"
              background-color="amber lighten-3"
            ></v-rating>

            <v-col
              class="grey--text ml-4 pa-0"
            >{{resource.average_rating}} ({{resource.ratings_count}})</v-col>
          </v-row>-->

          <div class="resource-card-details">
            <span>
              Age Group:
              {{
                resource.age_groups.length > 0
                  ? resource.age_groups.length == 1
                    ? resource.age_groups[0].name
                    : resource.age_groups[0].name + ` ...more`
                  : ""
              }}
            </span>

            <div
              class="mt-1"
              style="overflow: hidden; white-space:nowrap; text-overflow:ellipsis; width:100%; display:inline-block;"
            >
              Skills:
              <span
                v-for="(skill, i) in resource.skills.length > 2
                  ? resource.skills.slice(0, 2)
                  : resource.skills"
                :key="skill.name + i"
              >
                {{ skill.name }}{{ i > 0 ? "" : ", " }}
              </span>
            </div>

            <v-row no-gutters align="center">
              <v-chip
                class="me-1 resource-chip"
                v-for="(tag, i) in resource.tags.length < 3
                  ? resource.tags
                  : resource.tags.splice(2, resource.tags.length - 2)"
                :key="i"
                small
                style="max-width:90px"
              >
                {{ tag.name }}
              </v-chip>
            </v-row>
          </div>
        </v-card-text>

        <v-card-actions class="pa-0">
          <v-col align="center" class="pt-0">
            <div v-if="false">
              <v-row
                class="status-chip"
                justify="center"
                align="center"
                style="background-color: #FFF59E; border-color: #FFF59E;"
                v-if="resource.status == 'Pending' && isMyResource()"
              >
                <span
                  style=" font-weight: 800;font-size: 14px;line-height: 19px;color:#5C658B"
                  >Approval Pending</span
                >

                <v-icon color="#5C658B" right>mdi-clock-alert</v-icon>
              </v-row>

              <v-row
                class="status-chip"
                justify="center"
                align="center"
                style="background-color: #EFFCE5; border-color: #EFFCE5;"
                v-else-if="
                  resource.status == 'Approved' &&
                    (isMyResource() || isResourceManagemant()) &&
                    resource.privacy != 'Only me'
                "
              >
                <span
                  style=" font-weight: 800;font-size: 14px;line-height: 19px;color:#5C658B"
                  >Approved</span
                >

                <v-icon color="#5C658B" right>mdi-check</v-icon>
              </v-row>

              <v-row
                class="status-chip"
                justify="center"
                align="center"
                style="background-color: #FDDBDB; border-color: #FDDBDB;"
                v-else-if="
                  resource.status == 'Not-Approved' &&
                    (isMyResource() || isResourceManagemant())
                "
              >
                <span
                  style=" font-weight: 800;font-size: 14px;line-height: 19px;color:#5C658B"
                  >Not Approved</span
                >

                <v-icon color="#5C658B" right>mdi-close</v-icon>
              </v-row>

              <v-row
                class="status-chip"
                justify="center"
                align="center"
                style="background-color: #DEDEDE; border-color: #DEDEDE;"
                v-else-if="
                  resource.status == 'Approved' && isMyResource() && isVisible
                "
              >
                <span
                  style=" font-weight: 800;font-size: 14px;line-height: 19px;color:#5C658B"
                  >Draft Only</span
                >

                <v-icon color="#5C658B" right>mdi-file-outline</v-icon>
              </v-row>

              <v-row
                class="status-chip"
                justify="center"
                align="center"
                style="background-color: #FFD7D7; border-color: #FFD7D7;"
                v-else-if="
                  resource.status == 'deleted' && isMyResource() && isVisible
                "
              >
                <span
                  style=" font-weight: 800;font-size: 14px;line-height: 19px;color:#5C658B"
                  >Deleted</span
                >

                <v-icon color="#5C658B" right>mdi-file-outline</v-icon>
              </v-row>
            </div>
            <v-row
              v-if="isResourceManagemant() && resource.status == 'Pending'"
              class="ma-0 mt-2"
              justify="center"
              align="center"
            >
              <v-col>
                <v-btn
                  color="indigo accent-3"
                  class="addstudent-btn"
                  dark
                  outlined
                  @click="
                    () => {
                      isApproved = false;
                      confirmApprovalAction = true;
                    }
                  "
                  :loading="approvalLoading && !isApproved"
                >
                  <v-icon left>mdi-close</v-icon>Reject
                </v-btn>
              </v-col>
              <v-col>
                <v-btn
                  color="indigo accent-3"
                  class="addstudent-btn"
                  dark
                  @click="
                    () => {
                      isApproved = true;
                      confirmApprovalAction = true;
                    }
                  "
                  :loading="approvalLoading && isApproved"
                >
                  <v-icon left>mdi-check</v-icon>Approve
                </v-btn>
              </v-col>
            </v-row>

            <v-btn
              v-else-if="
                !isResourceManagemant() &&
                  !isPublicResource() &&
                  !authToken.is_eblity_admin() &&
                  resource.resource_type.name != 'Webinar'
              "
              color="indigo accent-3"
              class="addstudent-btn mt-2"
              :dark="resource.status != 'Approved' ? false : true"
              :disabled="resource.status != 'Approved' ? true : false"
              @click="addStudent"
              >Add to student</v-btn
            >
          </v-col>
        </v-card-actions>
      </v-card>
    </v-hover>
    <v-dialog v-model="confirmApprovalAction" max-width="568">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn
            tile
            large
            color="#5C658B"
            icon
            @click="confirmApprovalAction = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="confirmation-text">
          Are you sure you want to
          <strong>{{ isApproved ? "Approve" : "Reject" }}</strong> this
          resource?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="indigo accent-3"
            dark
            style="width:200px"
            class="mb-4 me-2"
            @click="approvalAction"
            :loading="approvalLoading"
            >Yes</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmDeleteAction" max-width="568" persistent>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn
            tile
            large
            color="#5C658B"
            icon
            @click="confirmDeleteAction = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="confirmation-text">
          Are you sure you want to
          <strong>Delete</strong> this resource?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="indigo accent-3"
            dark
            style="width:200px"
            class="mb-4 me-2"
            @click="deleteResource"
            :loading="deleteLoading"
            >Yes</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmDeleteAction" max-width="568" persistent>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn
            tile
            large
            color="#5C658B"
            icon
            @click="confirmDeleteAction = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="confirmation-text">
          Are you sure you want to
          <strong>Delete</strong> this resource?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="indigo accent-3"
            dark
            style="width:200px"
            class="mb-4 me-2"
            @click="deleteResource"
            :loading="deleteLoading"
            >Yes</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { ROUTER_URL, API_CLIENT_URL } from "../../constants/urls";
  import ClientApiHelper from "../../api/common/ClientApis";
  import Keys from "../../constants/keys";
  import Axios from "../../api/BaseAxios";

  import authToken from "../../common/authToken";
  import AmplitudeHelper from "../../amplitude";

  export default {
    name: "ResourceCard",
    props: ["resource"],
    data() {
      return {
        confirmApprovalAction: false,
        isApproved: false,
        approvalLoading: false,
        isVisible: true,
        authToken: authToken,
        confirmDeleteAction: false,
        deleteLoading: false,
      };
    },
    watch: {
      confirmDeleteAction() {
        if (this.confirmDeleteAction)
          AmplitudeHelper.registerEvent(
            "Resource - Delete - Click",
            this.resource
          );
      },
    },
    methods: {
      isPublicResource() {
        if (
          this.$route.name ==
            ROUTER_URL.publicResource.children.listResources.name ||
          this.$route.name ==
            ROUTER_URL.publicResource.children.resourceFiltered.name
        ) {
          return true;
        }
        return false;
      },
      isMyResource() {
        if (
          this.$route.name ==
          ROUTER_URL.clientPanel.children.resources.children.myResources.name
        ) {
          return true;
        }
        return false;
      },
      isResourceManagemant() {
        if (
          this.$route.name ==
          ROUTER_URL.clientPanel.children.resources.children.resourceManagemant
            .name
        ) {
          return true;
        } else if (
          this.$route.name ==
          ROUTER_URL.adminPanel.children.resources.children.resourceManagemant
            .name
        ) {
          return true;
        }
        return false;
      },
      isAllResources() {
        if (
          this.$route.name ==
            ROUTER_URL.clientPanel.children.resources.children.listResources
              .name ||
          this.$route.name ==
            ROUTER_URL.clientPanel.children.resources.children
              .sessionResourceList.name
        ) {
          return true;
        } else if (
          this.$route.name ==
          ROUTER_URL.adminPanel.children.resources.children.listResources.name
        ) {
          return true;
        }
        return false;
      },
      approvalAction() {
        var self = this;
        const successHandler = (res) => {
          console.log(res);

          if (self.isApproved)
            AmplitudeHelper.registerEvent(
              "Resource Management - Approve Resource",
              this.resource
            );
          else
            AmplitudeHelper.registerEvent(
              "Resource Management - Reject Resources",
              this.resource
            );

          self.confirmApprovalAction = false;
          self.approvalLoading = false;
          self.resource.status = self.isApproved ? "Approved" : "Not-Approved";
        };

        const failureHandler = (res) => {
          console.log(res);
          self.confirmApprovalAction = false;
          self.approvalLoading = false;
        };

        let requestParams = {};

        if (this.isApproved) {
          requestParams[Keys.STATUS] = 1;
        } else {
          requestParams[Keys.STATUS] = 0;
        }
        requestParams[Keys.RESOURCE_ID] = this.resource.id;

        this.approvalLoading = true;

        ClientApiHelper.updateResourceStatus(
          requestParams,
          successHandler,
          failureHandler
        );
      },
      gotoDetails() {
        AmplitudeHelper.registerEvent("Resource - View", this.resource);
        if (
          this.$route.name ==
            ROUTER_URL.publicResource.children.listResources.name ||
          this.$route.name ==
            ROUTER_URL.publicResource.children.resourceFiltered.name
        ) {
          this.$router.push({
            name: ROUTER_URL.publicResource.children.resourceDetails.name,
            params: {
              id: this.resource.id,
              title: this.resource.title.replace(/\s/g, "-"),
            },
            query: {
              utm_source: this.$store.state.userUTM.utm_source
                ? this.$store.state.userUTM.utm_source
                : "Referral",
              utm_medium: this.$store.state.userUTM.utm_medium
                ? this.$store.state.userUTM.utm_medium
                : "EblityPlatform",
              utm_campaign: this.$store.state.userUTM.utm_campaign
                ? this.$store.state.userUTM.utm_campaign
                : "ResourcesListPage",
            },
          });
        } else {
          if (authToken.is_eblity_admin()) {
            this.$router.push({
              name:
                ROUTER_URL.adminPanel.children.resources.children
                  .resourceDetails.name,
              params: { id: this.resource.id },
            });
          } else {
            this.$router.push({
              name:
                ROUTER_URL.clientPanel.children.resources.children
                  .resourceDetails.name,
              params: { id: this.resource.id },
            });
          }
        }
      },
      addRemoveBookmark() {
        var self = this;

        if (this.resource.is_bookmarked)
          AmplitudeHelper.registerEvent(
            "Resource - Remove Bookmark",
            this.resource
          );
        else
          AmplitudeHelper.registerEvent(
            "Resource - Add Bookmark",
            this.resource
          );

        const successHandler = (res) => {
          console.log(res);
        };

        const failureHandler = (res) => {
          console.log(res);
          self.resource.is_bookmarked = !this.resource.is_bookmarked;
        };

        this.resource.is_bookmarked = !this.resource.is_bookmarked;

        let requestParams = {};

        requestParams[Keys.IS_REMOVE] = !this.resource.is_bookmarked;
        requestParams[Keys.RESOURCE_ID] = this.resource.id;

        ClientApiHelper.addRemoveBookmark(
          requestParams,
          successHandler,
          failureHandler
        );
      },
      addStudent() {
        if (authToken.isCorrectAccessToken()) {
          this.$store.state.resourceToAdd = this.resource;
          this.$store.state.resourceAddStudentPopup = true;
        } else {
          this.$store.state.signinPopUp = true;
        }

        // store.dispatch("snackBar/showToast", {
        //   message:
        //     "Hang on! We’re currently developing this feature. Come back later!",
        //   color: "S",
        // });
      },
      deleteResource() {
        var self = this;

        this.deleteLoading = true;

        const successHandler = (res) => {
          console.log(res);
          self.deleteLoading = false;
          self.confirmDeleteAction = false;
          self.resource.status = "deleted";
        };

        const failureHandler = (res) => {
          console.log(res);
          self.deleteLoading = false;
        };

        let requestParams = {};
        requestParams[Keys.ID] = this.resource.id;

        Axios.request_DELETE(
          API_CLIENT_URL.resourceDelete,
          requestParams,
          {},
          successHandler,
          failureHandler,
          false
        );
      },
    },
    mounted() {
      if (
        this.$route.name ==
        ROUTER_URL.adminPanel.children.resources.children.resourceManagemant
          .name
      ) {
        this.isVisible = false;
      }
    },
  };
</script>

<style scoped>
  .confirmation-text {
    font-weight: 500;
    font-size: 1.125rem;
    line-height: 22px;

    color: #333333;
  }

  .btn {
    width: 50%;
  }

  .addstudent-btn {
    width: 100%;
  }

  .resource-card-title {
    font-weight: 800;
    font-size: 16px;
    line-height: 22px;
    min-height: 47px;
    color: #5c658b;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .resource-card-details {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;

    color: #333333;
  }
  .status-chip {
    border-radius: 16px;
    font-size: 14px;
    height: 32px;
    justify-content: center;
    width: 100%;
  }
</style>
<style>
  .resource-chip .v-chip__content {
    padding-top: 2px;
    width: 80px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }
</style>
